// Preview and branch deploys on *.netlify.app inherit the production GTM/GA4 IDs from the build env
// and the production Meta pixel ID from branding, so they pollute a client's real analytics data.
// Analytics is skipped on those hosts. Custom domains are never affected. A Netlify site that
// should report (e.g. a test site) lists its host in VUE_APP_ANALYTICS_ALLOWED_HOSTS, comma separated.

const PREVIEW_HOST_SUFFIX = '.netlify.app'

// TEMPORARY: pgtest is our analytics test site. Remove once GTM/GA4/Meta testing is done.
const TEMP_ALLOWED_HOSTS = ['pgtest.netlify.app']

export function analyticsAllowedOnHost(hostname = window.location.hostname) {
  const host = String(hostname).toLowerCase()
  if (!host.endsWith(PREVIEW_HOST_SUFFIX)) return true
  const allowedHosts = (process.env.VUE_APP_ANALYTICS_ALLOWED_HOSTS || '')
    .split(',')
    .map((allowedHost) => allowedHost.trim().toLowerCase())
    .filter(Boolean)
    .concat(TEMP_ALLOWED_HOSTS)
  return allowedHosts.includes(host)
}
